module.exports = __webpack_public_path__ + "static/media/coaching.13b27e65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coaching.svg
// module id = 454
// module chunks = 0